import { render } from "./testView.vue?vue&type=template&id=a3dc68be&scoped=true"
import script from "./testView.vue?vue&type=script&lang=js"
export * from "./testView.vue?vue&type=script&lang=js"

import "./testView.vue?vue&type=style&index=0&id=a3dc68be&lang=css"
import "./testView.vue?vue&type=style&index=1&id=a3dc68be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dc68be"]])

export default __exports__